<template>
  <div>
    <div
      class="modal fade"
      :ref="`modal-product-detail`"
      data-keyboard="false"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">
              {{ $t('service.servicePackage.title') }}
            </h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <div class="row form-group">
                  <div class="col-md-12">
                    <button
                      type="button"
                      class="btn btn-labeled btn-primary pull-right"
                      @click="onAddServicePackage"
                    >
                      <span class="btn-label">
                        <i class="fa fa-plus"></i>
                      </span>
                      {{ $t("common.addnew") }}
                    </button>
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <b-table
                  class="apartment-in-booking-table"
                  striped
                  hover
                  responsive
                  :items="servicePackageItems"
                  :fields="servicePackageFields"
                  ref="apartmentInBookingTable"
                >
                  <template #head()="scope">
                    <div class="">{{ $t(scope.label) }}</div>
                  </template>
                  <template #cell(totalFee)="row">
                    {{ currencyFormat(row.item.totalFee) }}
                  </template>
                  <template #cell(enable)="row">
                    <div style="text-align: center">
                      <i
                        v-if="row.item.enable"
                        style="font-size: x-large; color: green"
                        class="glyphicon glyphicon-ok-sign"
                      ></i>
                      <i
                        v-else
                        style="font-size: x-large; color: red"
                        class="glyphicon glyphicon-remove-sign"
                      ></i>
                    </div>
                  </template>
                  <template #cell(description)="row">
                    {{ spliceString(row.item.description, 25) }}
                  </template>
                  <template #cell(actions)="row">
                    <button
                      v-if="
                        GET_ACCOUNT_DATA.group_id == 1 || has_perm('update_service')
                      "
                      class="btn btn-primary btn-sm"
                      style="margin-left: 6px;"
                      :title="$t('common.modify')"
                      @click="onDetailServicePackage(row.item)"
                    >
                      <i class="glyphicon glyphicon-edit"></i>
                    </button>
                    <button
                      v-if="
                        GET_ACCOUNT_DATA.group_id == 1 || has_perm('delete_service')
                      "
                      class="btn btn-danger btn-sm"
                      style="margin-left: 6px;"
                      :title="$t('common.delete')"
                      @click="onOpenDelete(row.item)"
                    >
                      <i class="glyphicon glyphicon-trash"></i>
                    </button>
                  </template>
                </b-table>
                <div
                  v-if="servicePackageItems.length > 0"
                  class="box-footer clearfix"
                  style="display:contents;"
                >
                  <custom-paginator
                    :totalItem="paginateData.totalItem"
                    :currentPage="paginateData.currentPage"
                    :pageSize="paginateData.pageSize"
                    :totalPage="paginateData.totalPage"
                    @onpaginate="onCustomPagination"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              style="background-color: #f29911;border-color: #f29911;color:#fff"
              type="button"
              class="btn btn-default pull-left"
              @click="onCloseModal"
            >
              {{ $t("common.back") }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <!--  -->
    <div
      class="modal fade"
      :ref="`modal-service-package-detail`"
      data-keyboard="false"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">
              {{
                $t(
                  servicePackageData.id === 0
                    ? "service.servicePackage.addServicePackage"
                    : "service.servicePackage.servicePackageDetail"
                )
              }}
            </h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-6">
                <div class="form-group required">
                  <label class="control-label" for="">{{
                    $t("service.servicePackage.packageName")
                  }}</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="servicePackageData.packageName"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label class="control-label" for="">{{
                    $t("service.servicePackage.totalFee")
                  }}</label>
                  <input
                    type="number"
                    class="form-control"
                    v-model="servicePackageData.totalFee"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <input
                    id="servicePackageEnable"
                    type="checkbox"
                    v-model="servicePackageData.enable"
                  />
                  <label class="control-label" for="servicePackageEnable">{{
                    $t("common.enable")
                  }}</label>
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <label for="">{{
                    $t("common.description")
                  }}</label>
                  <textarea
                    name=""
                    id=""
                    cols="30"
                    rows="6"
                    class="form-control"
                    v-model="servicePackageData.description"
                  ></textarea>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="box-footer">
                <button
                  style="background-color: #f29911;border-color: #f29911;color:#fff"
                  type="button"
                  class="btn btn-default pull-left"
                  @click="onCloseServicePackageDetail"
                >
                  {{ $t("common.back") }}
                </button>
                <button
                  type="button"
                  class="btn btn-primary pull-right"
                  @click="onSaveServicePackage"
                >
                  {{ $t("common.save") }}
                </button>
              </div>
            </div>
          </div>
          <!-- <div class="modal-footer">
            <button
              style="background-color: #f29911;border-color: #f29911;color:#fff"
              type="button"
              class="btn btn-default pull-left"
              @click="onCloseModal"
            >
              {{ $t("common.back") }}
            </button>
          </div> -->
        </div>
      </div>
    </div>
    <!--  -->
    <lte-modal
      v-show="isModalVisible"
      @onConfirm="onConfirmDeleteServicePackage"
      @close="closeModal"
      v-for="obj in objModal"
      :key="obj.id"
      :item="obj"
    ></lte-modal>
  </div>
</template>
<script>
import utils from "@/lib/utils";
// import Enum from "../../../enum/enum";
import { mapActions, mapGetters } from "vuex";
import CustomPaginator from "@/components/CustomPaginator.vue";
import LTEModal from "@/components/LTEModal.vue";

export default {
  components: {
    CustomPaginator,
    "lte-modal": LTEModal
  },
  data: () => ({
    serviceId: null,
    //
    screenHight: 300,
    serviceUnitName: "",
    servicePackageFields: [
      {
        key: "nonumber",
        label: "common.nonumber"
      },
      {
        key: "packageName",
        label: "service.servicePackage.packageName"
      },
      {
        key: "totalFee",
        label: "service.servicePackage.totalFee"
      },
      {
        key: "enable",
        label: "common.enable"
      },
      {
        key: "description",
        label: "common.description"
      },
      { key: "actions", label: "common.action" }
    ],
    servicePackageItems: [],
    servicePackageData: {
      id: 0,
      packageName: null,
      totalFee: null,
      massCorresponding: null,
      enable: false,
      description: null
    },
    paginateData: {
      totalItem: 1,
      currentPage: 1,
      pageSize: 1,
      totalPage: 1
    },
    isModalVisible: false,
    originalRecordData: null,
    objModal: [
      {
        title: "common.delete_modal.title",
        body: "common.delete_modal.content",
        buttonNo: "common.delete_modal.btnNo",
        buttonYes: "common.delete_modal.btnYes",
        styleType: "default"
      }
    ]
  }),
  watch: {
    GET_SERVICE_PACKAGE_LIST_DATA: function() {
      let data = this.GET_SERVICE_PACKAGE_LIST_DATA.results;
      let paginate = this.GET_SERVICE_PACKAGE_LIST_DATA.paginate;
      this.paginateData = {
        totalItem: paginate.totalItem,
        currentPage: paginate.currentPage,
        pageSize: paginate.pageSize,
        totalPage: paginate.numPages
      };
      this.servicePackageItems = [];
      data.forEach((v, i) => {
        let nonumber =
          i +
          1 +
          (this.paginateData.currentPage - 1) * this.paginateData.pageSize;
        let item = {
          id: v.id,
          nonumber: nonumber,
          packageName: v.package_name,
          totalFee: v.total_fee,
          massCorresponding: v.mass_corresponding,
          description: v.description,
          enable: v.enable
        };
        this.servicePackageItems.push(item);
      });
    }
  },
  computed: {
    ...mapGetters([
      "GET_SERVICE_PACKAGE_LIST_DATA",
      "GET_ACCOUNT_DATA"
    ])
  },
  methods: {
    currencyFormat: function(value) {
      if (!utils.isEmptyString(value)) {
        return utils.formatNumber(value);
      }
      return null;
    },
    spliceString: function(strText, len) {
      return utils.spliceString(strText, len);
    },
    has_perm: function(perm) {
      return utils.has_perm(this.GET_ACCOUNT_DATA, perm);
    },
    onShowModal: function(serviceId, serviceUnitName) {
      this.serviceId = serviceId;
      this.serviceUnitName = serviceUnitName;
      $(this.$refs[`modal-product-detail`]).modal("show");
      this.getServicePackage(1);
    },
    onCloseModal: function() {
      $(this.$refs[`modal-product-detail`]).modal("hide");
    },
    showError: function(mess) {
      this.ON_SHOW_TOAST({
        message: mess,
        styleType: "danger"
      });
    },

    getServicePackage: function(page) {
      let filter = {
        params: {
          serviceId: this.serviceId,
          page: page
        }
      };
      this.GET_SERVICE_PACKAGE_LIST(filter);
    },
    /* */
    onShowServicePackageDetail: function() {
      $(this.$refs[`modal-service-package-detail`]).modal("show");
    },
    onCloseServicePackageDetail: function() {
      $(this.$refs[`modal-service-package-detail`]).modal("hide");
    },
    onAddServicePackage: function() {
      this.onShowServicePackageDetail();
      this.servicePackageData = {
        id: 0,
        packageName: null,
        totalFee: null,
        massCorresponding: null,
        description: null,
        enable: false
      };
    },
    onDetailServicePackage: function(data) {
      this.onShowServicePackageDetail();
      this.servicePackageData = {
        id: data.id,
        packageName: data.packageName,
        totalFee: data.totalFee,
        massCorresponding: data.massCorresponding,
        description: data.description,
        enable: data.enable
      };
    },
    onSaveServicePackage: function() {
      if (utils.isEmptyString(this.servicePackageData.packageName)) {
        this.showError(this.$t("service.servicePackage.packageName"));
      // } else if (utils.isEmptyString(this.servicePackageData.totalFee)) {
      //   this.showError(this.$t("service.servicePackage.totalFee"));
      } else {
        let data = {
          id: this.servicePackageData.id,
          packageName: this.servicePackageData.packageName,
          totalFee: utils.getCleanStringValue(this.servicePackageData.totalFee),
          massCorresponding: this.servicePackageData.massCorresponding,
          serviceId: this.serviceId,
          enable: this.servicePackageData.enable,
          description: this.servicePackageData.description
        };
        if (this.servicePackageData.id === 0) {
          this.ADD_SERVICE_PACKAGE(data)
            .then(
              function(res) {
                this.SUCCESS_TOAST();
                this.getServicePackage(this.paginateData.currentPage);
                this.$emit('callbackServiceList', true)
                this.onCloseServicePackageDetail();
              }.bind(this)
            )
            .catch(
              function(error) {
                this.ON_SHOW_TOAST({
                  message: error.response.data.message,
                  styleType: "danger"
                });
              }.bind(this)
            );
        } else {
          this.UPDATE_SERVICE_PACKAGE(data)
            .then(
              function(res) {
                this.SUCCESS_TOAST();
                this.getServicePackage(this.paginateData.currentPage);
                this.onCloseServicePackageDetail();
              }.bind(this)
            )
            .catch(
              function(error) {
                this.ON_SHOW_TOAST({
                  message: error.response.data.message,
                  styleType: "danger"
                });
              }.bind(this)
            );
        }
      }
    },
    onCustomPagination: function(data) {
      this.paginateData.currentPage = data;
      this.getServicePackage(data);
    },
    onOpenDelete: function(data) {
      this.originalRecordData = data;
      this.isModalVisible = true;
    },
    closeModal: function() {
      this.isModalVisible = false;
    },
    onConfirmDeleteServicePackage: function() {
      const payload = {
        id: this.originalRecordData.id
      };
      this.DELETE_SERVICE_PACKAGE(payload)
        .then(
          function(res) {
            this.SUCCESS_TOAST();
            this.closeModal()
            this.$emit('callbackServiceList', true)
            this.getServicePackage(this.paginateData.currentPage);
          }.bind(this)
        )
        .catch(
          function(error) {
            this.ON_SHOW_TOAST({
              message: error.response.data.message,
              styleType: "danger"
            });
          }.bind(this)
        );
    },
    ...mapActions([
      "SUCCESS_TOAST",
      "ERROR_TOAST",
      "ON_SHOW_TOAST",
      "ADD_SERVICE_PACKAGE",
      "UPDATE_SERVICE_PACKAGE",
      "GET_SERVICE_PACKAGE_LIST",
      "DELETE_SERVICE_PACKAGE"
    ])
  },
  mounted() {}
};
</script>
<style scoped>
input[type="file"] {
  display: none;
}
.form-group.required .control-label:after {
  content: " *";
  color: red;
  position: absolute;
  margin-left: 8px;
  top: 0px;
}
.asset-img-class {
  margin: auto;
  width: 100%;
  max-width: 200px;
  max-height: 200px;
  object-fit: contain;
}
.label-text-center {
  padding-bottom: 10px;
}
.remove-asset-img {
  color: #ef5350;
  cursor: pointer;
}
.disable-input {
  background: #e4e7e8;
}
</style>



// WEBPACK FOOTER //
// src/views/Service/ServicePackageModal.vue